export function calcularConsumoKwh({ consumoDinheiro, valorKwh }) {
  return Math.floor(consumoDinheiro * valorKwh);
};